import { render, staticRenderFns } from "./SchemeForm.vue?vue&type=template&id=5edd7a69"
import script from "./SchemeForm.vue?vue&type=script&lang=js"
export * from "./SchemeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports